module.exports = __webpack_public_path__ + "img/kolase4.b6eef29e.jpg";